var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.274 1 3 8.365v14.75l2.527 1.399V9.793l10.747-5.97 4.84 2.697.551-2.53L16.274 1zm-.36 21.392-.632-.362v-6.373l3.199-1.834-2.565-1.472-3.177 1.824v9.34l3.177 1.81 8.184-4.675-2.488-1.518-5.697 3.26zm-8.045 3.95v-15.01l8.068-4.656 8.07 4.657v.022l-2.48 1.427-5.59-3.22-5.588 3.231v12.09l5.588 3.232 10.55-6.095V9.885l2.48-1.45V23.48L15.938 31l-8.07-4.658z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFct);
export default __webpack_public_path__ + "static/media/FCT.d4832aef948cae1e046d3315147c6af2.svg";
export { ForwardRef as ReactComponent };